import gql from 'graphql-tag'

export const Q_GET_USER = gql`query($id:ID!) {
  user(id:$id) {
    id
    email,
    name,
    teams,
    currentTeam,
    groups,
    roles,
    isActive,
    phoneNumber,
    memberId
  }
}`

export const Q_GET_USERS = gql`
query ($where:ListWhere) {
  users (where:$where) {
    id,
     name,
    email,
    teams,
    currentTeam,
    groups,
    roles,
    isActive,
    phoneNumber,
    memberId
  }
}`

export const M_ADD_USER = gql`mutation ( $email:String!,$password:String!, $name:String!,
    $teams:[String],
    $currentTeam:String,
    $groups:[String],
    $roles:[String],
    $isActive:Boolean,
    $phoneNumber:String) {
  createUser (
    email:$email,
    name:$name,
    password:$password,
    teams:$teams,
    currentTeam:$currentTeam,
    groups:$groups,
    roles:$roles,
    isActive:$isActive,
    phoneNumber:$phoneNumber)
  {
    email,
    name,
    teams,
    currentTeam,
    groups,
    roles,
    isActive,
    phoneNumber
  }
}`

export const M_UPDATE_USER = gql`mutation ($id:Int!, $password:String, $oldPassword:String, $name:String,
    $teams:[String],
    $currentTeam:String,
    $groups:[String],
    $roles:[String],
    $isActive:Boolean,
    $phoneNumber:String) {
  updateUser (
    id:$id,
    name:$name,
    password:$password,
    oldPassword:$oldPassword,
    teams:$teams,
    currentTeam:$currentTeam,
    groups:$groups,
    roles:$roles,
    isActive:$isActive,
    phoneNumber:$phoneNumber)
  {
    id
    email,
    name,
    teams,
    currentTeam,
    groups,
    roles,
    isActive,
    phoneNumber
  }
}`

export const M_CREATE_MANY_USERS = gql`mutation($records:[UserInput]!) {
  createUsers(records:$records) {
    email,
    name
    teams,
    currentTeam,
    groups,
    roles,
    isActive
  }
}`

export const M_DELETE_USER = gql`mutation($where:ListWhere!) {
  deleteUser(where:$where)
}`

export const M_DELETE_USERS = gql`mutation($ids:[Int!]!) {
  deleteUsers(ids:$ids)
}`

export const Q_GET_API_KEYS = gql`query {
  myApiKeys {
    id
    name
    keyPrefix
    scopes
    lastUsedAt
    createdAt
    revokedAt
  }
}`

export const M_CREATE_API_KEY = gql`mutation($name:String, $scopes:[String]) {
  createApiKey(name:$name, scopes:$scopes) {
    apiKey {
      id
      name
      keyPrefix
      scopes
      createdAt
    }
    rawKey
  }
}`

export const M_REVOKE_API_KEY = gql`mutation($id:Int!) {
  revokeApiKey(id:$id)
}`
